import { sendGoogleEvent } from '@html/_common/utils';

const EVENT_CATEGORY = 'Sales Destinations';

export default function AOClpSaleDestinations() {
  const initiateTracking = () => {
    $('.js-ao-clp-sales-destinations__tiles-link').on('click', (event) => {
      const $clickedElement = $(event.currentTarget);
      const $clickedElementItem = $clickedElement.closest('.js-ao-clp-sales-destinations__tiles-item');
      const clickedElementLink = $clickedElement.attr('href');

      if (!clickedElementLink) return;

      sendGoogleEvent(
        EVENT_CATEGORY,
        clickedElementLink,
        `Index: ${$clickedElementItem.index() + 1}`,
      );
    });
  };

  return { initiate: initiateTracking };
}
